import axios from "axios";

import { MOBI_API_URL } from "../shared/constants";

/**
 * Mobi.Core — upload de anexo do chat (MOB-1632). Reaproveita a infra de upload do
 * Mobi.Core (a mesma das capturas): o sessionId da sala É o token_regulacao, então a
 * própria URL autentica. O POST cria a linha completa (hash, antifraude, histórico,
 * OCI, thumb) e devolve as URLs prontas — com isso o anexo já fica salvo e acessível
 * no histórico da vistoria (critério de aceite), sem depender do manager-service/S3.
 *
 * Usa /capturas — o MESMO endpoint da captura de foto da vistoria
 * (mobiService.uploadCaptura): multipart campo "file", SEM categoria, resposta
 * {idFoto, urlConteudo, urlThumb}. O /fotos exigia categoria (422 CATEGORY_NOT_FOUND);
 * /capturas nao exige e e o caminho ja provado pela captura. O anexo entra como captura
 * da vistoria (classificacao automatica aceita pelo produto). Parametrizado em
 * CHAT_ATTACHMENT_PATH.
 */
const mobiHost = axios.create({ baseURL: MOBI_API_URL });

const CHAT_ATTACHMENT_PATH = (sessionId: string) =>
  `/api/v1/regulacoes/${encodeURIComponent(sessionId)}/capturas`;

interface MobiUploadResponse {
  idFoto: number;
  arquivoFoto: string;
  thumbFoto: string;
  fraude: number;
  urlConteudo: string | null;
  urlThumb: string | null;
}

export interface UploadedChatAttachment {
  id: string;
  fileName: string;
  contentType: string;
  size: number;
  url: string;
  thumbUrl?: string;
}

export async function uploadChatAttachment(sessionId: string, file: File): Promise<UploadedChatAttachment> {
  const formData = new FormData();
  formData.append("file", file, file.name);

  const { data } = await mobiHost.post<MobiUploadResponse>(CHAT_ATTACHMENT_PATH(sessionId), formData);

  const url = data.urlConteudo || data.urlThumb;
  if (!url) {
    throw new Error("Mobi.Core: upload de anexo sem URL de conteúdo");
  }

  return {
    id: String(data.idFoto),
    fileName: file.name,
    contentType: file.type,
    size: file.size,
    url,
    thumbUrl: data.urlThumb || undefined,
  };
}
